import { render, staticRenderFns } from "./SubmitAnswersComponent.vue?vue&type=template&id=9c91f92e"
import script from "./SubmitAnswersComponent.vue?vue&type=script&lang=ts"
export * from "./SubmitAnswersComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports